import { render } from "./history-chat.vue?vue&type=template&id=fb470f78&scoped=true&ts=true"
import script from "./history-chat.vue?vue&type=script&lang=ts"
export * from "./history-chat.vue?vue&type=script&lang=ts"

import "./history-chat.vue?vue&type=style&index=0&id=fb470f78&lang=css&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb470f78"]])

export default __exports__